export default "__VITE_ASSET__CZOSV$Ko__"